import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { addItem } from "../redux/cartListSlice";
import QuantitySelector from "../components/QuantitySelector";
import { ToastContainer, toast } from "react-toastify";
import "../assets/ReactToastify.css";

export default function Product() {
  const [productData, setProductData] = useState({});
  const [stockQuantityArr, setStockQuantityArr] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const token = useSelector((state) => {
    return state.token;
  });

  const tokenBearer = token.token;
  const dispatch = useDispatch();

  const params = useParams();
  const cartList = useSelector((state) => state.cartList);

  const [insufficientStock, setInsufficientStock] = React.useState(false);

  const stockVerification = async (slug) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/stock/${slug}`
      );
      const stock = response.data;
      return stock;
    } catch (err) {
      console.log(err.data);
    }
  };

  const getAndSetProductData = useCallback(async (url) => {
    try {
      const res = await axios.get(url);
      setProductData(res.data);
    } catch (err) {
      console.log(err);
    }
  });

  const handleAddToCart = async (e, slug, quantity) => {
    e.preventDefault();
    toast.success("Product added to cart", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    const stock = await stockVerification(slug);
    const productInCart = cartList.some((item) => {
      return item.slug === slug;
    });
    if (!productInCart && stock >= quantity) {
      dispatch(addItem({ slug: slug, quantity: quantity }));
      setInsufficientStock(false);
    } else {
      cartList.map((item) => {
        if (item.slug === slug && stock >= item.quantity + quantity) {
          dispatch(addItem({ slug: slug, quantity: quantity }));
          setInsufficientStock(false);
        } else {
          setInsufficientStock(true);
        }
      });
    }
  };

  useEffect(() => {
    getAndSetProductData(
      `${process.env.REACT_APP_API_URL}/products/${params.slug}`
    );
  }, []);

  useEffect(() => {
    const optionsArr = [];
    for (let i = 1; i <= productData?.stock; i++) {
      optionsArr.push(
        <option key={"option-" + i} value={i}>
          {i}
        </option>
      );
    }

    setStockQuantityArr(optionsArr);
  }, [productData, insufficientStock]);

  const handleQuantityInc = () => {
    if (selectedQuantity + 1 <= productData.stock) {
      setSelectedQuantity((prev) => prev + 1);
    }
  };

  const handleQuantityDec = () => {
    if (selectedQuantity - 1 >= 1) {
      setSelectedQuantity((prev) => prev - 1);
      setInsufficientStock(false);
    }
  };

  return (
    <>
      {!productData?.name ? (
        ""
      ) : (
        <section className="item-details section">
          <div className="container">
            <div className="top-area wow bounceIn">
              <div className="row align-items-start">
                <div className="col-lg-6 col-md-12 col-12">
                  <div className="product-images">
                    <main id="gallery">
                      <div className="main-img ">
                        <img
                          // src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/laderhack/products/${productData.img}`}
                          src={`../img/ProductImg2/${productData.img}`}
                          id="current"
                          alt="#"
                        />
                      </div>
                      <div className="images">
                        {/* <img
                        src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.camera-rumors.com%2Fwp-content%2Fuploads%2F2018%2F02%2Fsony-a7iii-sample-image-3.jpg&f=1&nofb=1"
                        className="img"
                        alt="#"
                      /> */}
                        {/* <img
                        src="assets/images/product-details/02.jpg"
                        className="img"
                        alt="#"
                      />
                      <img
                        src="assets/images/product-details/03.jpg"
                        className="img"
                        alt="#"
                      />
                      <img
                        src="assets/images/product-details/04.jpg"
                        className="img"
                        alt="#"
                      />
                      <img
                        src="assets/images/product-details/05.jpg"
                        className="img"
                        alt="#"
                      />  */}
                      </div>
                    </main>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-12">
                  <div className="product-info d-flex flex-column align-items-start">
                    <h2 className="title text-start">{productData.name}</h2>
                    <p className="category">
                      <span className="p-0 m-0 text-decoration-none text-capitalize">
                        {productData.category}
                      </span>
                    </p>
                    <h3
                      style={{ color: "rgb(213, 179, 117)" }}
                      className="price"
                    >
                      ${productData.price}
                    </h3>
                    <p className="info-text text-start">
                      {productData.description}
                    </p>

                    <div className="bottom-content m-0 mt-1">
                      <div className="row align-items-end">
                        <div className="col-lg-12 col-md-12 col-12 d-flex justify-content-start align-items-center mb-3">
                          <div className="d-flex justify-content-left align-items-baseline quantity-selector">
                            <p className="p-0 m-0 fs-6 d-inline-flex justify-content-center align-items-center">
                              Quantity:
                              <QuantitySelector
                                val={selectedQuantity}
                                onDec={handleQuantityDec}
                                onInc={handleQuantityInc}
                              />
                            </p>
                            {insufficientStock && (
                              <p>
                                Insufficient stock. Please check again in 2-3
                                business days.
                              </p>
                            )}
                            {/* <label className="me-2" htmlFor="quantity">
                              Quantity:
                            </label>
                            <select
                              value={selectedQuantity}
                              onChange={(e) =>
                                setSelectedQuantity(e.target.value)
                              }
                              name="quantity"
                              id="quantity"
                              className="p-1"
                            >
                              {stockQuantityArr.map((quantity) => quantity)}
                            </select> */}
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-12">
                          <div className="button cart-button">
                            <button
                              style={{ backgroundColor: "rgb(213, 179, 117)" }}
                              className="btn px-2 lh-1"
                              onClick={(e) => {
                                handleAddToCart(
                                  e,
                                  productData.slug,
                                  selectedQuantity
                                );
                              }}
                            >
                              Add to Cart
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="product-details-info wow fadeInUp">
              <div className="single-block">
                <div className="row d-flex justify-content-between">
                  <div className="col-lg-5 col-12">
                    <div className="info-body custom-responsive-margin">
                      <h4 className="m-0 p-0 mb-2 text-start">Ingredients</h4>
                      <p className=" text-start info-text">
                        {productData.ingredients}
                      </p>
                      {/* <h4>Features</h4>
                    <ul className="features">
                      <li>Capture 4K30 Video and 12MP Photos</li>
                      <li>Game-Style Controller with Touchscreen</li>
                      <li>View Live Camera Feed</li>
                      <li>Full Control of HERO6 Black</li>
                      <li>Use App for Dedicated Camera Operation</li>
                    </ul> */}
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="info-body d-flex flex-column align-items-start justify-content-center">
                      <h4 className="m-0 p-0 mb-2 d-block text-start">
                        Nutritional Information
                      </h4>
                      <table id="table-nutri" className="table">
                        {/* <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                          </tr>
                        </thead> */}
                        <tbody>
                          {productData.nutritional_info
                            .split(" , ")
                            .map((spec) => (
                              <tr key={spec}>
                                <td
                                  className="w-50 text-start ps-0"
                                  scope="row"
                                >
                                  {spec
                                    .split(" ")
                                    .slice(0, -1)
                                    .map((word, i) =>
                                      i === 0
                                        ? `${word
                                            .split("")[0]
                                            .toUpperCase()}${word
                                            .split("")
                                            .slice(1)
                                            .join("")}`
                                        : word
                                    )
                                    .join(" ")}
                                </td>
                                <td className="text-end ">
                                  {spec.split(" ").slice(-1)[0]}
                                </td>
                                {/* <li key={spec}>{spec}</li> */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {/* <h4>Shipping Options:</h4>
                    <ul className="normal-list">
                      <li>
                        <span>Courier:</span> 2 - 4 days, $22.50
                      </li>
                      <li>
                        <span>Local Shipping:</span> up to one week, $10.00
                      </li>
                      <li>
                        <span>UPS Ground Shipping:</span> 4 - 6 days, $18.00
                      </li>
                      <li>
                        <span>Unishop Global Export:</span> 3 - 4 days, $25.00
                      </li>
                    </ul> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* <div
        className="modal fade review-modal"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Leave a Review
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="review-name">Your Name</label>
                    <input
                      className="form-control"
                      type="text"
                      id="review-name"
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="review-email">Your Email</label>
                    <input
                      className="form-control"
                      type="email"
                      id="review-email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="review-subject">Subject</label>
                    <input
                      className="form-control"
                      type="text"
                      id="review-subject"
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label for="review-rating">Rating</label>
                    <select className="form-control" id="review-rating">
                      <option>5 Stars</option>
                      <option>4 Stars</option>
                      <option>3 Stars</option>
                      <option>2 Stars</option>
                      <option>1 Star</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label for="review-message">Review</label>
                <textarea
                  className="form-control"
                  id="review-message"
                  rows="8"
                  required
                ></textarea>
              </div>
            </div>
            <div className="modal-footer button">
              <button type="button" className="btn">
                Submit Review
              </button>
            </div>
          </div>
        </div>
      </div> */}
      {/* <footer className="footer">
        <div className="footer-top">
          <div className="container">
            <div className="inner-content">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-12">
                  <div className="footer-logo">
                    <a href="index.html">
                      <img src="assets/images/logo/white-logo.svg" alt="#" />
                    </a>
                  </div>
                </div>
                <div className="col-lg-9 col-md-8 col-12">
                  <div className="footer-newsletter">
                    <h4 className="title">
                      Subscribe to our Newsletter
                      <span>
                        Get all the latest information, Sales and Offers.
                      </span>
                    </h4>
                    <div className="newsletter-form-head">
                      <form
                        action="#"
                        method="get"
                        target="_blank"
                        className="newsletter-form"
                      >
                        <input
                          name="EMAIL"
                          placeholder="Email address here..."
                          type="email"
                        />
                        <div className="button">
                          <button className="btn">
                            Subscribe<span className="dir-part"></span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-middle">
          <div className="container">
            <div className="bottom-inner">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="single-footer f-contact">
                    <h3>Get In Touch With Us</h3>
                    <p className="phone">Phone: +1 (900) 33 169 7720</p>
                    <ul>
                      <li>
                        <span>Monday-Friday: </span> 9.00 am - 8.00 pm
                      </li>
                      <li>
                        <span>Saturday: </span> 10.00 am - 6.00 pm
                      </li>
                    </ul>
                    <p className="mail">
                      <a href="mailto:support@shopgrids.com">
                        support@shopgrids.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="single-footer our-app">
                    <h3>Our Mobile App</h3>
                    <ul className="app-btn">
                      <li>
                        <a href="javascript:void(0)">
                          <i className="lni lni-apple"></i>
                          <span className="small-title">Download on the</span>
                          <span className="big-title">App Store</span>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                          <i className="lni lni-play-store"></i>
                          <span className="small-title">Download on the</span>
                          <span className="big-title">Google Play</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="single-footer f-link">
                    <h3>Information</h3>
                    <ul>
                      <li>
                        <a href="javascript:void(0)">About Us</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">Contact Us</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">Downloads</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">Sitemap</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">FAQs Page</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="single-footer f-link">
                    <h3>Shop Departments</h3>
                    <ul>
                      <li>
                        <a href="javascript:void(0)">Computers & Accessories</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">Smartphones & Tablets</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">TV, Video & Audio</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">Cameras, Photo & Video</a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">Headphones</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="inner-content">
              <div className="row align-items-center">
                <div className="col-lg-4 col-12">
                  <div className="payment-gateway">
                    <span>We Accept:</span>
                    <img
                      src="assets/images/footer/credit-cards-footer.png"
                      alt="#"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  <div className="copyright">
                    <p>
                      Designed and Developed by
                      <a
                        href="https://graygrids.com/"
                        rel="nofollow"
                        target="_blank"
                      >
                        GrayGrids
                      </a>
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-12">
                  <ul className="socila">
                    <li>
                      <span>Follow Us On:</span>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-facebook-filled"></i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-twitter-original"></i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-google"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer> */}
    </>
  );
}
